import axios from 'axios'

const LoadTexts = ({ commit }) => {
    axios.get('/api/texts/').then(response => {
        const texts = (response.data || []).reduce((reduced, textData) => {
            reduced[textData.key] = textData.content;

            return reduced;
        }, {});

        commit('SET_TEXTS', texts)
    }).catch(
        (error) => commit('ADD_ERROR_MESSAGE', 'TEXTS_NOT_LOADED')
    )
};

export default LoadTexts
